import 'reflect-metadata';

import './assets/scss/app.scss';
import './plugins/buefy';
import './plugins/components';
import './plugins/directives';
import './plugins/filters';
import './plugins/vee-validate';
import './plugins/vue-color';

import Vue from 'vue';

import App from './App.vue';
import i18n from './plugins/i18n';
import container from './plugins/services';
import router from './router';

Vue.config.productionTip = false;

new Vue({
	router,
	i18n,
	provide: {
		...container.getAll()
	},
	render: h => h(App)
}).$mount('#app');
